import request from '@/utils/axios.js'
// 查询新闻列表
export const getNewsList = params => {
  return request({
    method: 'GET',
    url: '/api/newsList',
    params
  })
}
// 查询新闻分类列表
export const getNewsCateList = () => {
  return request({
    method: 'GET',
    url: '/api/newsCateList'
  })
}
